module.exports = __webpack_public_path__ + "img/selected6-min.475ca8cd.png";